import axios from "axios";

export const getCategories = async (companyId) => {
    const response = await axios.get(`api/taskincidentcategories/${companyId}`);
    const result = response.data;
    return result;
}

export const postCategory = async (data) => {
    const response = await axios.post("api/taskincidentcategories", data);
    const result = response.data;
    return result;
}

export const patchCategory = async (data) => {
    const response = await axios.patch("api/taskincidentcategories", data);
    const result = response.data;
    return result;
}

export const deleteCategory = async (id) => {
    const response = await axios.delete(`api/taskincidentcategories/${id}`);
    const result = response.data;
    return result;
}



// export const deleteLink = async (linkId) => {
//     const response = await axios.delete(`api/tasklinks/${linkId}`);
//     const result = response.data;
//     return result;
// }

// export const postLink = async (data) => {
//     const response = await axios.post("api/tasklinks", data);
//     const result = response.data;
//     return result;
// }